export enum PersonTypeEnum {
    /**
     * Pessoa física
     */
    pf = 7,

    /**
     * Pessoa jurídica
     */
    pj = 11
}